import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import SafetyForm from './pages/SafetyForm';
import OAuthSuccess from './pages/OAuthSuccess';
import OAuthError from './pages/OAuthError';
import Home from './pages/Home';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Dashboard pages
import { DashboardLayout, Overview, Analytics, FormLinks, LinkDetail } from './pages/Dashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Toaster position="top-right" />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<SafetyFormOrHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/form/:jobId/:token" element={<SafetyForm />} />
            <Route path="/connect/success" element={<OAuthSuccess />} />
            <Route path="/connect" element={<OAuthError />} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />
            <Route path="/oauth-error" element={<OAuthError />} />

            {/* Dashboard routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Overview />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="links" element={<FormLinks />} />
              <Route path="links/:shortCode" element={<LinkDetail />} />
            </Route>

            {/* Short code form route (must be last) */}
            <Route path="/:code" element={<SafetyForm />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

// Show SafetyForm if ?code= is present, otherwise show Home
function SafetyFormOrHome() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  
  if (code) {
    return <SafetyForm />;
  }
  
  return <Home />;
}

export default App;